import { render, staticRenderFns } from "./historia.vue?vue&type=template&id=5d262d4a&scoped=true"
import script from "./historia.vue?vue&type=script&lang=js"
export * from "./historia.vue?vue&type=script&lang=js"
import style0 from "./historia.vue?vue&type=style&index=0&id=5d262d4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d262d4a",
  null
  
)

export default component.exports